"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));

var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.655 6.333a.9.9 0 01.001 1.273l-4.103 4.108a.4.4 0 000 .566l4.103 4.109a.9.9 0 01.08 1.18l-.08.092a.9.9 0 01-1.273 0l-4.1-4.108a.4.4 0 00-.567 0l-4.1 4.107a.9.9 0 11-1.273-1.272l4.103-4.108a.4.4 0 000-.566L6.343 7.606a.9.9 0 01-.08-1.18l.081-.093a.9.9 0 011.273.001l4.099 4.106a.4.4 0 00.566 0l4.1-4.106a.9.9 0 011.273 0z"
})), "0 0 24 24", "Close");

exports.default = _default;